import { render } from "./BuyNewProxyPage.vue?vue&type=template&id=ba4764a8"
import script from "./BuyNewProxyPage.vue?vue&type=script&lang=js"
export * from "./BuyNewProxyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__